import styled from 'styled-components';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import breakpoints from 'assets/theme/base/breakpoints';

const { values: { md } } = breakpoints;

export const StyledAppBar = styled.div`
	padding: 2rem 0%;
`;

export const DesktopTitle = styled(Typography)`
	display: none;
	margin-right: 16px;
	@media (min-width: ${md}px) {
		display: flex;
	}
`;

export const MobileMenuBox = styled(Box)`
	display: flex;
	flex-grow: 0;
	align-items: center;
	@media (min-width: ${md}px) {
		display: none;
	}
`;

export const TabsRegion = styled.div`
	flex-grow: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 1.5rem;
`;

export const MobileTabsRegion = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 16px 8px 0 8px;
	width: 100%;
	border-top: 1px solid rgba(0, 0, 0, 0.12);
	margin-top: 8px;
`;

export const MobileTitle = styled(Typography)`
	display: flex;
	flex-grow: 1;
	margin-right: 16px;
	@media (min-width: ${md}px) {
		display: none;
	}
`;

export const DesktopActionsBox = styled(Box)`
	display: none;
	justify-content: flex-end;
	flex-grow: 0;
	padding-right: 24px;
	@media (min-width: ${md}px) {
		display: flex;
	}
`;

export const LogoImage = styled.img`
	height: 60px;
	width: auto;
`;

export const StyledHomeButton = styled(Button)`
	color: white !important;
	display: block;
	padding: .8rem 1.7rem;

`; 